var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleOtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.5,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5.5,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.9C10 5.67909 10.1791 5.5 10.4 5.5H11.6C11.8209 5.5 12 5.67909 12 5.9V11.1C12 11.3209 11.8209 11.5 11.6 11.5H10.4C10.1791 11.5 10 11.3209 10 11.1V5.9Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 3.01074C13.2128 3.113 14 3.96435 14 5V12L13.9893 12.2041C13.8938 13.1457 13.1457 13.8938 12.2041 13.9893L12 14H4C2.96435 14 2.113 13.2128 2.01074 12.2041L2 12V5C2 3.89543 2.89543 3 4 3H12L12.2041 3.01074ZM4 4C3.44772 4 3 4.44772 3 5V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V5C13 4.44772 12.5523 4 12 4H4Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleOtl);
export default __webpack_public_path__ + "static/media/Schedule_otl.a333e252fe0f9a384161f7f4aea90ac8.svg";
export { ForwardRef as ReactComponent };